import styled from 'styled-components';

export const FieldList = styled.ul`
  margin: 16px 0;
  padding-left: 20px;
`;

export const FieldItem = styled.li`
  margin-bottom: 8px;
  color: ${({ theme }) => theme.palette.text.secondary};
`;
